<div class="status-history-card">
  <mat-accordion *ngIf="historyStatuses as statuses" class="status-list" multi>
    <ng-content></ng-content>
    <div *ngFor="let status of statuses" class="status-item sub-item" [ngClass]="conditionClassMap[status.condition]">
      <div class="expansion-panel-point"></div>
      <mat-expansion-panel [disabled]="status.dates && status.dates.length === 0">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span> {{ status.statusCode }} {{ status.statusCodeDescription }} </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="status-list__head">
          <div class="status-list__cell">
            {{ 'shipment.statusHistory.received' | translate }}
          </div>
          <div class="status-list__cell">
            {{ 'shipment.statusHistory.estimated' | translate }}
          </div>
          <div *ngIf="hasPredictedDateTime && status.statusCode === statusCodes.S31" class="status-list__cell">
            {{ 'shipment.statusHistory.estimatedSG' | translate }}, {{ betaFlag }}
          </div>
          <div *ngIf="hasPredictedDateTime && status.statusCode === statusCodes.S31" class="status-list__cell">
            {{ 'shipment.statusHistory.predicted' | translate }}, {{ betaFlag }}
          </div>
          <div *ngIf="status.statusCode === statusCodes.S31" class="status-list__cell">
            {{ 'shipment.statusHistory.estimatedBestFit' | translate }}
          </div>
          <div class="status-list__cell">
            {{ 'shipment.statusHistory.actual' | translate }}
          </div>
        </div>
        <div *ngFor="let item of status.dates" class="status-list__row">
          <ui-svg-icon
            *ngIf="item.origin === statusHistoryOrigin.ShipsGo"
            [name]="iconNames.AlertInfo"
            [matTooltip]="'shipment.statusHistory.milestoneByDaas' | translate"
            class="status-list__icon"
          ></ui-svg-icon>
          <div class="status-list__cell cropped">
            <span class="status-list__name">{{ 'shipment.statusHistory.received' | translate }}: </span>
            <ui-date-with-profile-and-local-timezone
              *ngIf="item.receivedDateTime as receivedTime"
              [timestamp]="receivedTime.timestamp"
              [localTimezoneData]="receivedTime.localTimezoneData"
              [profileTimezoneData]="receivedTime.profileTimezoneData"
              class="tw-overflow-hidden tw-text-ellipsis"
            ></ui-date-with-profile-and-local-timezone>

            <ui-svg-icon
              *ngIf="item.origin === statusHistoryOrigin.IftstaManual"
              [name]="iconNames.TouchPit"
              class="tw-ml-3"
              [matTooltip]="'shipment.statusHistory.manualSourceTooltip' | translate"
              [width]="20"
            ></ui-svg-icon>
            <ui-svg-icon
              *ngIf="item.origin === statusHistoryOrigin.GeoFence"
              [name]="iconNames.MapCity"
              [width]="20"
              class="tw-ml-3 geo-fence"
            ></ui-svg-icon>
            <ui-svg-icon
              *ngIf="item.origin === statusHistoryOrigin.ShippeoETA"
              [name]="iconNames.LocatorTracking"
              [matTooltip]="'shipment.statusHistory.calculatedETA' | translate"
              class="tw-ml-3 shippeo-eta"
            ></ui-svg-icon>
          </div>
          <div class="status-list__cell cropped">
            <span class="status-list__name">{{ 'shipment.statusHistory.estimated' | translate }}: </span>
            <ui-date-with-profile-and-local-timezone
              *ngIf="item.estimatedDateTime as estimatedTime"
              [timestamp]="estimatedTime.timestamp"
              [localTimezoneData]="estimatedTime.localTimezoneData"
              [profileTimezoneData]="estimatedTime.profileTimezoneData"
              class="tw-overflow-hidden tw-text-ellipsis"
            ></ui-date-with-profile-and-local-timezone>
          </div>
          <div *ngIf="hasPredictedDateTime && status.statusCode === statusCodes.S31" class="status-list__cell cropped">
            <span class="status-list__name"> {{ 'shipment.statusHistory.estimatedSG' | translate }}: </span>
            <ui-date-with-profile-and-local-timezone
              *ngIf="item.shipsGoEstimatedDateTime as predicted"
              [timestamp]="predicted.timestamp"
              [localTimezoneData]="predicted.localTimezoneData"
              [profileTimezoneData]="predicted.profileTimezoneData"
              class="tw-overflow-hidden tw-text-ellipsis"
            ></ui-date-with-profile-and-local-timezone>
          </div>
          <div *ngIf="hasPredictedDateTime && status.statusCode === statusCodes.S31" class="status-list__cell cropped">
            <span class="status-list__name">{{ 'shipment.statusHistory.predicted' | translate }}: </span>
            <ui-date-with-profile-and-local-timezone
              *ngIf="item.intrackEstimatedDateTime as predicted"
              [timestamp]="predicted.timestamp"
              [localTimezoneData]="predicted.localTimezoneData"
              [profileTimezoneData]="predicted.profileTimezoneData"
              class="tw-overflow-hidden tw-text-ellipsis"
            ></ui-date-with-profile-and-local-timezone>
          </div>
          <div *ngIf="status.statusCode === statusCodes.S31" class="status-list__cell cropped">
            <span class="status-list__name">{{ 'shipment.statusHistory.estimatedBestFit' | translate }}: </span>
            <span class="bestfit-eta-source">
              {{ item.bestfitOrigin ? bestfitOriginDisplayMap[item.bestfitOrigin] : '' }}</span
            >
            <ui-date-with-profile-and-local-timezone
              *ngIf="item.bestfitEstimatedDateTime as predicted"
              [timestamp]="predicted.timestamp"
              [localTimezoneData]="predicted.localTimezoneData"
              [profileTimezoneData]="predicted.profileTimezoneData"
              class="tw-overflow-hidden tw-text-ellipsis"
            ></ui-date-with-profile-and-local-timezone>
          </div>
          <div class="status-list__cell cropped">
            <span class="status-list__name">{{ 'shipment.statusHistory.actual' | translate }}: </span>
            <ui-date-with-profile-and-local-timezone
              *ngIf="item.actualDateTime as actualTime"
              [timestamp]="actualTime.timestamp"
              [localTimezoneData]="actualTime.localTimezoneData"
              [profileTimezoneData]="actualTime.profileTimezoneData"
              class="tw-overflow-hidden tw-text-ellipsis"
            ></ui-date-with-profile-and-local-timezone>
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  </mat-accordion>
</div>
